import { render, staticRenderFns } from "./Reach.vue?vue&type=template&id=5665210b&"
import script from "./Reach.vue?vue&type=script&lang=js&"
export * from "./Reach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports